'use strict';

import { formWithPaymentSubmitElements } from "./elements/formWithPaymentSubmitElements";
import {PROVIDER} from "../PaymentOptions/PaymentOptions";

export default class FormWithPaymentSubmit
{
    paymentOptions = null;

    constructor(paymentOptions, formId) {
        this.elements = formWithPaymentSubmitElements(formId);
        this.submit = this.onSubmit.bind(this);
        this.paymentOptions = paymentOptions;
        this.addEventListeners();
    }

    addEventListeners() {
        this.elements.form.addEventListener('submit', this.submit);
    }

    onSubmit(event) {
        if (this.paymentOptions.elements.donationAmount === null) {
            return;
        }
        event.preventDefault();
        if (this.paymentOptions.formType === PROVIDER &&
            this.paymentOptions.elements.donationAmount.value === '0'
        ) {
            this.elements.form.submit();
            return;
        }
        if (
            (
                this.paymentOptions.amount !== null &&
                this.paymentOptions.amount !== this.paymentOptions.OTHER &&
                this.paymentOptions.elements.donationAmount.value === ''
            ) || (
                this.paymentOptions.amount === this.paymentOptions.OTHER &&
                this.paymentOptions.elements.donationAmount.value !== ''
            )
        ) {
            this.elements.form.submit();
        } else {
            this.paymentOptions.showValidationError();
        }
    }
}
